<template>
  <div class="comp">
    <el-dialog
      :title="''"
      :visible="dialogState"
      :close-on-click-modal="false"
      width="400px"
      @close="dialogClose"
    >
      <div class="title">请使用微信或支付宝扫描下方二维码</div>
      <div class="body">
        <div
          style="
            width: 300px;
            height: 300px;
            padding: 30px 25px 20px;
            margin: auto;
          "
          ref="qrCodeDiv"
        ></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import qrcodejs2 from "qrcodejs2";
export default {
  data() {
    return {
      dialogState: true,
      daojishi: null,
    };
  },
  props: {
    QRCode: {
      type: String,
      default: "",
    },
    orderNum: {
      type: String,
      default: "",
    },
    payType: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.$nextTick(() => {
      new qrcodejs2(this.$refs.qrCodeDiv, {
        text: this.QRCode,
        width: 300,
        height: 300,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: qrcodejs2.CorrectLevel.M, //容错率，L/M/H
      });
      this.daojishi = setInterval(() => {
        this.payInterval();
      }, 5000);
    });
  },
  methods: {
    dialogClose() {
      if (this.daojishi) {
        clearInterval(this.daojishi);
      }
      this.$emit("submit", "close");
    },
    payInterval() {
      let params = {
        orderNum: this.orderNum,
        payType: 1,
        shopId: this.$store.state.shopId,
      };
      this.$http.get("/api/Pay/PayState", params).then((res) => {
        if (res.code == 0) {
          if (res.data == "success") {
            this.$message({
              message: "支付成功",
              type: "success",
            });
            if (this.daojishi) {
              clearInterval(this.daojishi);
            }
            this.$emit("submit", "success");
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.comp {
  .title {
    font-size: 20px;
    text-align: center;
  }
}
</style>
